import { Tag } from "antd";
import { useTranslation } from "react-i18next";
import { PresetColors } from "../../../../common/constants";
import { CommissionAdvanceStatus } from "../enums";

const getCommissionAdvanceStatusColor = (status: CommissionAdvanceStatus) => {
  switch (status) {
    case CommissionAdvanceStatus.ACTIVE:
      return PresetColors.BLUE;
    case CommissionAdvanceStatus.OVERDUE:
      return PresetColors.ORANGE;
    case CommissionAdvanceStatus.CANCELLED:
      return PresetColors.RED;
    case CommissionAdvanceStatus.COMPLETED:
      return PresetColors.GREEN;
  }
};

interface Props {
  status: CommissionAdvanceStatus;
}

export const CommissionAdvanceStatusTag = ({ status }: Props) => {
  const { t } = useTranslation();

  return (
    <Tag color={getCommissionAdvanceStatusColor(status)} style={{ marginRight: 0 }}>
      {t("commissions.advance.enums.status." + status)}
    </Tag>
  );
};
